export const REFRESH_JWT_REQUEST = 'REFRESH_JWT_REQUEST'
export const REFRESH_JWT_SUCCESS = 'REFRESH_JWT_SUCCESS'
export const REFRESH_JWT_ERROR = 'REFRESH_JWT_ERROR'
export const REFRESH_JWT_RESET = 'REFRESH_JWT_RESET'
